<template>
  <div>
    <div class="row">
      <breadcrumb>
        <template v-slot:1>
          <router-link :to="{ name: 'informes' }">{{
            $t("informes")
          }}</router-link>
        </template>
        <template v-slot:2>{{ $t("ventasPorComensales") }}</template>
      </breadcrumb>
      <CabeceraInformes
        :idBusiness="idBusiness"
        :listBusinesses="listBusinesses"
        :idTpv="idTpv"
        :listTpv="listTpv"
        :dateto="dateto"
        :datefrom="datefrom"
        id="cabecera"
        :conTodos="true"
      />
      <template v-if="!permiso">
        <div class="alert alert-danger m-3" style="width: 100%" role="alert">
            Lo sentimos. Este negocio no cuenta con este módulo activado.
        </div>
      </template>
      <div class="col-md-12" v-else-if="respuesta && retail">
        <template v-if="list.length > 0">
          <div class="row justify-content-between div-export ">
            <div class="col-md-12  text-left">
              <el-dropdown>
                <el-button type="primary" size="small">
                  <i class="fa fa-file"></i>
                  {{ $t("exportarInforme")
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <a :href="urlExportPDF">
                    <el-dropdown-item class="text-danger">
                      <strong
                        ><i class="fa fa-file-pdf"></i>
                        {{ $t("exportarPdf") }}</strong
                      >
                    </el-dropdown-item>
                  </a>
                  <a :href="urlExportExcel">
                    <el-dropdown-item class="text-success">
                      <strong
                        ><i class="fa fa-file-excel"></i>
                        {{ $t("exportarExcel") }}</strong
                      >
                    </el-dropdown-item>
                  </a>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-bordered table-striped text-nowrap">
              <thead class="thead-dark">
                <tr>
                  <th>
                    <span
                      v-if="ordenacionFecha"
                      @click="sort('initDate'), (ordenacionFecha = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("fecha") }}
                    </span>
                    <span
                      v-else
                      @click="sort('initDate'), (ordenacionFecha = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("fecha") }}
                    </span>
                  </th>
                  <th>
                    <span
                      v-if="ordenacionnumComensales"
                      @click="
                        sort('numComensales'), (ordenacionnumComensales = 0)
                      "
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("numeroDeComensales") }}</span
                    >
                    <span
                      v-else
                      @click="
                        sort('numComensales'), (ordenacionnumComensales = 1)
                      "
                    >
                      <i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("numeroDeComensales") }}</span
                    >
                  </th>
                  <th>
                    <span
                      v-if="ordenacionVentas"
                      @click="sort('sales'), (ordenacionVentas = 0)"
                    >
                      <i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("ventas") }}</span
                    >
                    <span v-else @click="sort('sales'), (ordenacionVentas = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("ventas") }}</span
                    >
                  </th>
                  <th
                    v-if="ordenacionPrecioMedio === 0"
                    @click="sortedArrayPrecioMedioASC()"
                  >
                    <i style="color: white" class="fa fa-angle-up"></i>
                    {{ $t("precioMedioPorComensal") }}
                  </th>
                  <th v-else @click="sortedArrayPrecioMedioDESC()">
                    <i style="color: white" class="fa fa-angle-down"></i>
                    {{ $t("precioMedioPorComensal") }}
                  </th>
                  <th
                    v-if="ordenacionPrecioMedio === 0"
                    @click="sortedArrayPrecioMedioTicketASC()"
                  >
                    <i style="color: white" class="fa fa-angle-up"></i>
                    Precio medio por ticket
                  </th>
                  <th v-else @click="sortedArrayPrecioMedioTicketDESC()">
                    <i style="color: white" class="fa fa-angle-down"></i>
                    Precio medio por ticket
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="obj in sorted">
                  <td>
                    <span :class="getClassDay(obj.initDate)"
                      >{{ obj.initDate | getDia }}
                      {{ obj.initDate | parseDate }}</span
                    >
                  </td>
                  <td align="right">{{ obj.numComensales }}</td>
                  <td align="right">{{ obj.sales | currency }}</td>
                  <td align="center" v-if="obj.numComensales === 0">-</td>
                  <td align="right" v-else>
                    {{ (obj.sales / obj.numComensales) | currency }}
                  </td>
                  <td align="right" v-if="obj.numTickets > 0">
                    {{ (obj.sales / obj.numTickets) | currency }}
                  </td>
                  <td v-else>-</td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="table-success">
                  <td>
                    <strong>{{ $t("total") }}</strong>
                  </td>
                  <td class="text-right">
                    <strong>{{ getTotalComensales }}</strong>
                  </td>
                  <td class="text-right">
                    <strong>{{ getTotalVentas | currency }}</strong>
                  </td>
                  <td class="text-right">
                    <strong>{{ getTotalPrecioMed | currency }}</strong>
                  </td>
                  <td class="text-right">
                  <strong>
                    <i
                      v-tooltip.top-center="
                            'Este valor no es un sumatorio de los precios medios. Es el precio medio total.'
                          "
                      class="fa fa-info-circle"
                    >
                    </i>
                    {{ getTotalPrecioMedTickets | currency }}</strong>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </template>
        <template v-else>
          <div class="alert alert-danger" role="alert">
            {{ $t("noHay") }} <strong>{{ $t("ventasMinusculas") }} </strong>
            {{ $t("rangoDeFechas") }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Chart from "chart.js";
import {
  DatePicker,
  Select,
  Loading,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb.vue";
import Datetime from "vue-datetime";
import moment from "moment";
import { mapState } from 'vuex';

export default {
  created() {
    this.loading = Loading.service({ text: "Cargando..." });

    this.$store.dispatch("setNameRoute", this.$i18n.t("ventasPorComensales"));
    this.getBusiness();

    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Datetime]: Datetime,
    Breadcrumb,
    CabeceraInformes,
  },
  data() {
    return {
      loading: false,
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),
      listBusinesses: [],
      value4: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(),
      ],
      idBusiness: 0,
      list: ["-"],
      mode: 0,
      $Chart: null,
      objectChart: null,
      contador: 0,
      chartIn: 0,
      listTpv: [],
      idTpv: -1,
      dateRangeOptions1: {
        firstDayOfWeek: 1,
      },

      //ORDENAR
      currentSort: "name",
      currentSortDir: "asc",
      ordenacionPrecioMedio: 0,
      ordenacionFecha: 0,
      ordenacionnumComensales: 0,
      ordenacionVentas: 0,

      respuesta: true,
      retail: true,
    };
  },
  computed: {
    ...mapState(["permiso"]),
    sorted: function() {
      return this.list.sort((a, b) => {
        let modifier = 1;
        if (this.currentSortDir === "desc") modifier = -1;
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
        return 0;
      });
    },

    urlExportPDF() {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportVentasComensal/PDF?idTpv=" +
        this.idTpv +
        "&idBusiness=" +
        this.idBusiness +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportExcel() {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportVentasComensal/Excel?idTpv=" +
        this.idTpv +
        "&idBusiness=" +
        this.idBusiness +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },

    getTotalVentas() {
      let total = 0;
      this.list.forEach(function(d) {
        total += d.sales;
      });
      return total;
    },

    getTotalPrecioMed() {
      let total = 0;
      let sales = 0;
      let numComensales = 0;
      this.list.forEach(function(d) {
        if (d.numComensales !== 0) {
          sales += d.sales;
          numComensales += d.numComensales;
        }
      });

      total = sales / numComensales;
      return total;
    },
    getTotalPrecioMedTickets() {
      let total = 0;
      let sales = 0;
      let numTickets = 0;
      this.list.forEach(function(d) {
        if (d.numTickets !== 0) {
          sales += d.sales;
          numTickets += d.numTickets;
        }
      });

      total = sales / numTickets;
      return total;
    },
    getTotalComensales() {
      let total = 0;
      this.list.forEach(function(d) {
        total += d.numComensales;
      });
      return total;
    },
  },

  methods: {
    getTpv() {
      this.listTpv = [];

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function(response) {
          if (response.data.response) {
            vm.listTpv = response.data.result;
            if (vm.listTpv.length > 0) {
              vm.getSalesComensales();
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally((_) => {
          vm.loading.close();
        });
    },
    cambioBusiness(idBusinessData, listTpv) {
      if (listTpv) {
        this.listTpv = listTpv;
      }
      
      this.loading = Loading.service({ text: "Cargando..." });
      this.idBusiness = idBusinessData;
      this.idTpv = -1;
      this.list = [];
      this.retail = true;
      this.getConfigTpvRetail();
      this.cambioTpv();
    },
    emitirConsulta() {
      if (!this.retail) {
        swal({
          title: "Negocio tipo RETAIL",
          text: "Esta información no esta disponible para su modelo de negocio",
          confirmButtonClass: "btn btn-info btn-fill",
          type: "info",
        });
      }
      this.getSalesComensales();
    },
    cambioTpv(idTpvData, filtrar) {

      if (idTpvData != undefined) {
        this.idTpv = idTpvData;
      }
      
      this.emitirConsulta();
    },
    cambioHora(dates) {
      this.datefrom = dates[0];
      this.dateto = dates[1];
    },
    sortedArrayPrecioMedioASC: function() {
      this.ordenacionPrecioMedio = 1;

      function compare(a, b) {
        if (a.numComensales === 0 && b.numComensales === 0) {
          return -1;
        } else if (a.numComensales !== 0 && b.numComensales === 0) {
          return 1;
        } else if (a.numComensales === 0 && b.numComensales !== 0) {
          return -1;
        } else {
          if (a.sales / a.numComensales < b.sales / b.numComensales) return -1;
          if (a.sales / a.numComensales > b.sales / b.numComensales) return 1;
          return 0;
        }
      }

      return this.sorted.sort(compare);
    },
    sortedArrayPrecioMedioDESC: function() {
      this.ordenacionPrecioMedio = 0;

      function compare(a, b) {
        if (a.numComensales === 0 && b.numComensales === 0) {
          return 1;
        } else if (a.numComensales !== 0 && b.numComensales === 0) {
          return -1;
        } else if (a.numComensales === 0 && b.numComensales !== 0) {
          return 1;
        } else {
          if (a.sales / a.numComensales > b.sales / b.numComensales) return -1;
          if (a.sales / a.numComensales < b.sales / b.numComensales) return 1;
          return 0;
        }
      }

      return this.sorted.sort(compare);
    },

    sortedArrayPrecioMedioTicketsASC: function() {
      this.ordenacionPrecioMedio = 1;

      function compare(a, b) {
        if (a.numTickets === 0 && b.numTickets === 0) {
          return -1;
        } else if (a.numTickets !== 0 && b.numTickets === 0) {
          return 1;
        } else if (a.numTickets === 0 && b.numTickets !== 0) {
          return -1;
        } else {
          if (a.sales / a.numTickets < b.sales / b.numTickets) return -1;
          if (a.sales / a.numTickets > b.sales / b.numTickets) return 1;
          return 0;
        }
      }

      return this.sorted.sort(compare);
    },
    sortedArrayPrecioMedioTicketDESC: function() {
      this.ordenacionPrecioMedio = 0;

      function compare(a, b) {
        if (a.numTickets === 0 && b.numTickets === 0) {
          return 1;
        } else if (a.numTickets !== 0 && b.numTickets === 0) {
          return -1;
        } else if (a.numTickets === 0 && b.numTickets !== 0) {
          return 1;
        } else {
          if (a.sales / a.numTickets > b.sales / b.numTickets) return -1;
          if (a.sales / a.numTickets < b.sales / b.numTickets) return 1;
          return 0;
        }
      }

      return this.sorted.sort(compare);
    },

    sort: function(s) {
      //if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      }
      this.currentSort = s;
    },

    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }
          vm.getConfigTpvRetail();
          vm.cambioTpv(-1, false);
        })
        .catch(function(error) {
          console.log(error);
        }); 
    },
    getConfigTpvRetail() {
      var config = {
          params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 84,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios.get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function(response) {
          if (response.data.response) {
            
            vm.retail = false;

            swal({
            title: "Negocio tipo RETAIL",
            text: "Esta información no esta disponible para su modelo de negocio",
            confirmButtonClass: "btn btn-info btn-fill",
            type: "info",
            });

          } else {
            vm.retail = true;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getSalesComensales() {
      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.loading = Loading.service({ text: "Cargando..." });

          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          var config = {
            params: {
              idBusiness: this.idBusiness,
              idTpv: this.idTpv,
              datefrom: moment(this.datefrom)
                .startOf("day")
                .unix(),
              dateto: moment(this.dateto)
                .endOf("day")
                .unix(),
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .get(
              this.$store.getters.apiUrl + "sales/getSalesComensalesByBusiness",
              config
            )
            .then(function(response) {
              if (response.data.response) {
                vm.list = response.data.result;

                vm.respuesta = true;
              } else if (response.data.response == false && response.data.rangoMayor == true) {
                    swal({
                      title: "Lo sentimos",
                      text: response.data.result,
                      confirmButtonClass: "btn btn-info btn-fill",
                      type: "info",
                    });
                    vm.respuesta = false;
              } else {
                swal({
                  title: vm.$t("accesoDenegado"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });

                vm.respuesta = false;
              }
              vm.loading.close();
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      }
    },
    getClassDay(date) {
      var classDay = "";
      var humanDate = moment.unix(date);
      var dia = moment(humanDate).format("d");

      if (dia === "0") {
        classDay = "sunday";
      } else if (dia == 5 || dia == 6) {
        classDay = "fridaySaturday";
      }

      return classDay;
    },
  },
};
</script>

<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.sunday {
  color: rgb(128, 0, 0);
}

.fridaySaturday {
  color: rgb(0, 128, 64);
}

.div-export {
  margin-bottom: 10px;
}

th span {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Ventas/VentasPorComensales.vue